// Etiqueta original da Logística Reversa (TASK-1808): regras puras de como a resposta de
// GET /api/reverse/original/:tag preenche a tela.

// Campos da tela a partir do documento gravado no envio original: nota fiscal (chave, número, série) ou,
// quando o envio usou declaração de conteúdo, "Emitir DC-E" (tipo 3) com conteúdo, quantidade e valor.
// O código da DC-E da ida nunca vem. Nulo = etiqueta sem documento (a tela não mexe no que o usuário
// já preencheu).
export function nfeFormPatch(nfe) {
  if (!nfe || (!nfe.key && !nfe.number && !nfe.dceId && !nfe.content && nfe.typeContent !== "3")) return null;
  const patch = {
    typeContent: nfe.typeContent === "2" || nfe.typeContent === "3" ? nfe.typeContent : "1",
    nfeKey: nfe.key || "",
    nfeNumber: nfe.number || "",
    nfeSerie: nfe.serie || "",
    dceId: nfe.dceId || "",
  };
  if (nfe.content) {
    patch.content = nfe.content;
    patch.quantity = +nfe.quantity > 0 ? +nfe.quantity : 1;
  }
  if (+nfe.value > 0) {
    // "Valor" da tela: na nota fiscal, o valor do documento; na DC-E, o preço unitário da linha (é o que
    // os Correios esperam no item). O valor do documento (valuedeclared) é o total da declaração quando vem.
    patch.value = +nfe.value;
    patch.valuedeclared = +nfe.declaredValue > 0 ? +nfe.declaredValue : +nfe.value;
  }
  return patch;
}

// Padrão da tela dos campos que o documento da etiqueta preenche (valor fica de fora: o usuário o edita).
const FORM_DEFAULTS = {
  typeContent: "1",
  nfeKey: "",
  nfeNumber: "",
  nfeSerie: "",
  dceId: "",
  content: "",
  quantity: 1,
};

// Ao trocar de etiqueta: volta ao padrão o que a etiqueta anterior preencheu e a nova não preenche,
// desde que o usuário não tenha mexido (não apaga o que ele digitou). `previous` = último patch aplicado.
export function nfeFormReset(previous, next, current) {
  const reset = {};
  if (!previous) return reset;
  for (const key of Object.keys(FORM_DEFAULTS)) {
    if (!(key in previous) || (next && key in next)) continue;
    if (String(current[key]) === String(previous[key])) reset[key] = FORM_DEFAULTS[key];
  }
  return reset;
}

// O cliente que o usuário já escolheu vale mais que o da etiqueta: os serviços de reversa (e a
// Reversa Consolidada) dependem do cliente escolhido e não do dono da etiqueta. Sem escolha, usa o da etiqueta.
export function customerForOriginalTag(selected, fromTag) {
  return {
    customer: selected || fromTag || "",
    mismatch: !!selected && !!fromTag && selected !== fromTag,
  };
}
